module.exports = __webpack_public_path__ + "288535709fe2eb1804ed8b2aa5190d02.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/laptop-s.png
// module id = 2054
// module chunks = 0